<script>
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import { readErrorId } from "%/dynamic-component-editor/helpers/error-id";

export default {
  name: "ErrorId",
  extends: TextElement,
  mixins: [DynamicElementMixin],
  elementPanelSettings: {
    displayName: "Error ID",
    displayIcon: "material-symbols:error",
    elementGroup: "error",
    elementType: "element",
  },
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return readErrorId();
    },
  },
};
</script>
